import { http, staleWhileRevalidateConfig } from '@/core/helpers/http.helper';
import { TMDBGenre } from '@/core/store/tmdb/tmdb-genre.interface';

export class GenreService {
   async getMovieGenres() {
      const response = await http.get<{ genres: Array<TMDBGenre> }>('/genre/movie/list?language=en', staleWhileRevalidateConfig);
      return response.data.genres;
   }
   async getSerieGenres() {
      const response = await http.get<{ genres: Array<TMDBGenre> }>('/genre/tv/list?language=en', staleWhileRevalidateConfig);
      return response.data.genres;
   }
}
